import { SVGProps } from 'react';

export const ShareArrowUpIcon = ({
  stroke = '#202020',
  width = 15,
  height = 17,
  ...otherProps
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    fill='none'
    viewBox='0 0 15 17'
    {...otherProps}
  >
    <path
      stroke={stroke}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.3'
      d='M3.983 6.483H2.317C1.396 6.483.65 7.23.65 8.15v5.833c0 .921.746 1.667 1.667 1.667h10c.92 0 1.666-.746 1.666-1.667V8.15c0-.92-.746-1.667-1.666-1.667H10.65M7.317.65v9.167m0-9.167-2.5 2.5m2.5-2.5 2.5 2.5'
    ></path>
  </svg>
);
